import PageWrapper from 'components/utils/PageWrapper';
import ChartViewer from 'pages/ChartViewer';

export const chartsRoutes = {
    path: '/charts',
    element: (
        <PageWrapper titleId="charts_title">
            <ChartViewer />
        </PageWrapper>
    ),
};
